<div class="app-layout">
  <!-- Toolbar fixe en haut -->
  <mat-toolbar class="mat-elevation-z3 toolbar" style="border-radius: 0">
    <div class="uk-text-center uk-padding-small" >
      <button matFab aria-label="Menu" class="uk-hidden@m" (click)="switchedCollapsed()" style="background-color: var(--mat-button-filled-container-color); color: white">
        <mat-icon>menu</mat-icon>
      </button>
      <img [src]="getLogoName()" style="width: 50px; cursor:pointer;" class="uk-visible@m" alt="Logo" routerLink="/home"/>
    </div>
    <div class="uk-flex-1 uk-hidden@m"></div>
    <div class="uk-flex-1">
      <img [src]="getLogoName()" style="width: 50px; cursor:pointer;" class="uk-hidden@m" alt="Logo"/>
    </div>
    <div class="uk-flex-1 uk-hidden@m"></div>
    @if (canSeeNotifications) {
      <button matIconButton [matMenuTriggerFor]="notificationMenu" aria-label="Notifications"
              class="uk-margin-small-right">
        <mat-icon [matBadge]="notifications.length" [matBadgeHidden]="notifications.length === 0"
                  matBadgeColor="warn">notifications</mat-icon>
      </button>
      <mat-menu #notificationMenu="matMenu">
        @if (notifications.length === 0) {
          <button mat-menu-item disabled>Aucune notification</button>
        }
        @for (notification of notifications; track notification.id) {
          <button mat-menu-item (click)="openNotification(notification)">
            <span style="font-weight: bold">{{ notification.title }}</span><br/>
            <span>{{ notification.content }}</span><br/>
            <span style="font-size: 12px; color: gray">
              {{ notification.creationDateTime | date: 'dd MMM yyyy à HH:mm' }}
            </span>
          </button>
        }
      </mat-menu>
    }
    <button matButton="filled" mat-flat-button color="warn" class="logout-btn" (click)="logout()"
            matTooltip="Déconnexion" style="background-color: var(--mat-button-filled-container-color)">
      <mat-icon>logout</mat-icon>
      <span class="uk-visible@m">Déconnexion</span>
    </button>
  </mat-toolbar>

  <!-- Sidenav container qui prend le reste de l'espace -->
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav
      mode="side"
      [opened]="!collapsed"
      class="sidenav"
      style="background: var(--menu-background-color); border-radius: 0;"
    >
      <mat-nav-list class="[--mat-list-active-indicator-shape:0px] mb-6">
        @for (item of menuItems; track item.label) {
          @if (item.available | async) {
            <mat-list-item
              [routerLink]="item.route"
              routerLinkActive
              #rla="routerLinkActive"
              [activated]="rla.isActive"
            >
              <button matIconButton matListItemIcon>
                <mat-icon style="color: var(--menu-text-color)">{{ item.icon }}</mat-icon>
              </button>
              <span style="color: var(--menu-text-color)">
              {{ item.label }}
              </span>
            </mat-list-item>
          }
        }
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content class="content">
      <div style="padding-left: 50px; padding-right: 50px">
        <router-outlet></router-outlet>
      </div>


    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
